// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 601) return "js/core/601.js";
	if (chunkId === 166) return "js/core/166.js";
	if (chunkId === 8) return "js/core/8.js";
	// return url for filenames based on template
	return undefined;
};